var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckApprove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_200_5029",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 18.3333C11.0946 18.3347 12.1787 18.1198 13.1899 17.7009C14.2012 17.2821 15.1196 16.6675 15.8926 15.8925C16.6676 15.1195 17.2822 14.201 17.7011 13.1898C18.1199 12.1786 18.3348 11.0945 18.3334 9.99997C18.3348 8.90541 18.1199 7.82138 17.701 6.81014C17.2821 5.79891 16.6676 4.88043 15.8926 4.10747C15.1196 3.33248 14.2012 2.71788 13.1899 2.299C12.1787 1.88012 11.0946 1.66521 10.0001 1.66663C8.90554 1.66524 7.8215 1.88015 6.81027 2.29903C5.79904 2.71791 4.88055 3.3325 4.10759 4.10747C3.33262 4.88043 2.71804 5.79891 2.29916 6.81014C1.88028 7.82138 1.66536 8.90541 1.66676 9.99997C1.66534 11.0945 1.88024 12.1786 2.29912 13.1898C2.718 14.201 3.3326 15.1195 4.10759 15.8925C4.88055 16.6674 5.79904 17.282 6.81027 17.7009C7.8215 18.1198 8.90554 18.3347 10.0001 18.3333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 10L9.16675 12.5L14.1667 7.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_200_5029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckApprove);
export default __webpack_public_path__ + "static/media/checkApprove.081d680005458a252aeedc5e8a34dbd7.svg";
export { ForwardRef as ReactComponent };